"use client"

/**
 * Client-side mirror of the `new-tests-pages` release flag. Now backed
 * entirely by the `RELEASE_NEW_TESTS_PAGES` env var (read server-side and
 * passed in via `initialValue`). With no per-visitor variability there's
 * nothing for the client to override — the hook is a passthrough so the
 * existing call sites can stay unchanged.
 */
export function useNewTestsPagesEnabled(initialValue = false) {
  return initialValue
}
